export class EventSource {
	constructor() {

	}

	addEventListener(eventName, listener) {
		if (typeof this.listeners === "undefined") this.listeners = {};
		if (!this.listeners.hasOwnProperty(eventName)) this.listeners[eventName] = [];
		this.listeners[eventName].push(listener);
	}

	fireEvent(eventName, eventObject) {
		if (!eventObject) eventObject = {};
		eventObject.source = this;
		if (this.listeners) {
			const all = this.listeners[eventName];
			if (all) {
				for (let lsnr of all) {
					lsnr(eventObject);
				}
			}
		}
	}
}